// import VideoModal from '../ModalVideo/VideoModal'
// import { Link } from 'react-router-dom'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'

const AboutMission = (props) => {
  // const ClickHandler = () => {
  //   window.scrollTo(0, 0)
  // }

  return (
    <section id="about" className={'' + props.hclass}>
      <div className="about-wrap-mission container">
        <div className="about-content-mission">
          <div className="content-mission">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Vision
            </h2>
            <p className="fade_bottom">
              To lead in the global energy sector by harmonizing the demand for oil and gas with a commitment to sustainable practices and continuous innovation. Integrity is at our core—guiding each decision with transparency and responsibility. Safety is paramount, protecting our team, communities, and the environment. We value innovation, always seeking new ways to enhance efficiency and minimize environmental impact. Above all, we are commi˲ed to sustainability, balancing today's energy needs with a vision for a greener future. These principles drive us forward as we contribute to the world’s energy supply and safeguard the planet for future generations.
            </p>
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Mission
            </h2>
            <p className="fade_bottom">
              Apex Energy Corporation is committed to responsibly exploring, developing, and producing oil and natural gas resources, with a steadfast focus on safety, environmental stewardship, and community engagement. Our mission centers on fueling progress industry while promoting sustainable growth. Recognizing the critical role of energy in powering global development, we strive to provide reliable and efficient solutions that meet international demand. Our commitment, however, extends beyond energy production; we are equally focused on reducing our environmental footprint, investing in cleaner technologies, and prioritizing safety and operational excellence. Together, we are shaping a sustainable energy future that balances progress with environmental responsibility.
            </p>
          </div>
        </div>
      </div>
       <div className="break-who"></div>
      {/* <div className="about-section-who container">
        <div className="content-who">
          <h2
            className="scroll-text-animation"
            data-animation="fade_from_right"
          >
            Who We Are?
          </h2>
          <p className="fade_bottom">
            The roots of our foundation dates back for almost two decades, A to
            Z Construction Company is a cornerstone of growth and innovation in
            Iraq’s construction sector. With expertise spanning architecture,
            contracting, and investment, we have consistently set new standards
            for quality and reliability.
          </p>
          <p className="fade_bottom">
            At A to Z, we don’t just build structures; we create lasting value.
            Our integrated approach covers every phase of developmentfrom
            architectural design and project supervision to construction and
            strategic investment. This seamless process ensures that each
            project is exec.
          </p>
          <p className="fade_bottom">
            Backed by a legacy of trust and a forward-thinking mindset, A to Z
            Construction Company is committed to elevating infrastructure across
            Iraq, contributing to both urban expansion and economic progress.
            Our projects are a testament to our craftsmanship, innovation, and
            unwavering commitment to excellence.
          </p>
        </div>
       
        <div>
          <div className="image ">
            <div className="image-2 poort-in-right">
              <img className="img-about " src={abImg3} alt="" />
            </div>
          </div>
        </div>
      </div> */}
    </section>
  )
}

export default AboutMission
